module.exports = __webpack_public_path__ + "static/media/xuebao.8df7e592.png";